




import { Component, Vue } from 'vue-property-decorator'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave',
])

@Component({})
export default class App extends Vue {}
